import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Frame, Navigation } from '@shopify/polaris';
import {
  HomeIcon,
  PackageIcon,
  NotificationIcon,
  SettingsIcon,
  CreditCardIcon,
  ChartVerticalIcon,
} from '@shopify/polaris-icons';
import { useState, useCallback } from 'react';

// Pages
import Dashboard from './pages/Dashboard';
import Shipments from './pages/Shipments';
import ShipmentDetail from './pages/ShipmentDetail';
import Notifications from './pages/Notifications';
import Settings from './pages/Settings';
import Billing from './pages/Billing';

function AppContent() {
  const [mobileNavigationActive, setMobileNavigationActive] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMobileNavigation = useCallback(
    () => setMobileNavigationActive((active) => !active),
    []
  );

  const navigationMarkup = (
    <Navigation location={location.pathname}>
      <Navigation.Section
        items={[
          {
            label: 'Tableau de bord',
            icon: HomeIcon,
            selected: location.pathname === '/',
            onClick: () => navigate('/'),
          },
          {
            label: 'Expéditions',
            icon: PackageIcon,
            selected: location.pathname.startsWith('/shipments'),
            onClick: () => navigate('/shipments'),
          },
          {
            label: 'Notifications',
            icon: NotificationIcon,
            selected: location.pathname === '/notifications',
            onClick: () => navigate('/notifications'),
          },
          {
            label: 'Analytiques',
            icon: ChartVerticalIcon,
            disabled: true,
            badge: 'Bientôt',
          },
        ]}
      />
      <Navigation.Section
        title="Configuration"
        items={[
          {
            label: 'Paramètres',
            icon: SettingsIcon,
            selected: location.pathname === '/settings',
            onClick: () => navigate('/settings'),
          },
          {
            label: 'Abonnement',
            icon: CreditCardIcon,
            selected: location.pathname === '/billing',
            onClick: () => navigate('/billing'),
          },
        ]}
      />
    </Navigation>
  );

  return (
    <Frame
      navigation={navigationMarkup}
      showMobileNavigation={mobileNavigationActive}
      onNavigationDismiss={toggleMobileNavigation}
    >
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/shipments" element={<Shipments />} />
        <Route path="/shipments/:id" element={<ShipmentDetail />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Frame>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
